var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { PageContent } from '@project/components/Page';
import { ContentPadding } from '@project/components/base';
import { Checkbox } from '@kiwicom/orbit-components/lib';
import Modal from '../Modal';
import ButtonLink from '../ButtonLink';
import { Input, Label } from '../Forms/Fields';
import toast from '../Toast';
import { PermissionsWrapper } from '../PermissionsWrapper';
import { getCategories } from '../../containers/Root/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectCategories } from '../../containers/Root/selectors';
export var CategoryCreationModal = function (_a) {
    var _b;
    var open = _a.open, _c = _a.data, data = _c === void 0 ? {} : _c, handleClose = _a.handleClose, handleGoBack = _a.handleGoBack, handleCategoryCreation = _a.handleCategoryCreation, _d = _a.selectedOrganizationId, selectedOrganizationId = _d === void 0 ? null : _d;
    var _e = useState(''), label = _e[0], setLabel = _e[1];
    var _f = useState(false), global = _f[0], setGlobal = _f[1];
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(getCategories(selectedOrganizationId));
    }, [dispatch, selectedOrganizationId]);
    var categories = (_b = useSelector(selectCategories)) !== null && _b !== void 0 ? _b : [];
    useEffect(function () {
        if (data.label)
            setLabel(data.label);
        if (data.global)
            setGlobal(data.global);
    }, [data.label, data.global]);
    var clearInputFields = function () {
        setGlobal(false);
        setLabel('');
    };
    var handleSaveCategory = function () {
        if (label) {
            if (data === null || data === void 0 ? void 0 : data.label) {
                handleCategoryCreation(__assign(__assign({}, data), { label: label, global: global, organization: selectedOrganizationId }));
                clearInputFields();
            }
            else {
                if (!categories.filter(function (cat) { return cat.label === label; }).length) {
                    handleCategoryCreation({
                        label: label,
                        global: global,
                        organization: selectedOrganizationId,
                    });
                    clearInputFields();
                }
                else {
                    toast.error('Category exists');
                }
            }
        }
        else {
            toast.error('Category Label Cannot be empty');
        }
    };
    var handleBack = function () {
        clearInputFields();
        handleGoBack();
    };
    return (_jsx(Modal, __assign({ headerTitle: "".concat((data === null || data === void 0 ? void 0 : data.label) ? 'Edit' : 'Create', " Categories"), open: open, onClose: function () {
            clearInputFields();
            handleClose();
        }, headerContent: _jsx("div", __assign({ style: { width: '50%', float: 'left' } }, { children: _jsx("div", __assign({ style: { float: 'left', display: 'inline-block' } }, { children: _jsx(ButtonLink, __assign({ onClick: handleBack }, { children: "Back" })) })) })), footerContent: _jsx(PermissionsWrapper, __assign({ action: "update", target: global
                ? 'org:apt:templatecategories'
                : "org:".concat(selectedOrganizationId, ":templatecategories") }, { children: _jsx(ButtonLink, __assign({ onClick: handleSaveCategory }, { children: "Save" })) })) }, { children: _jsx(PageContent, { children: _jsxs(ContentPadding, __assign({ centered: true }, { children: [_jsx(Label, { children: "Category Label" }), _jsx(PermissionsWrapper, __assign({ action: "update", target: global
                            ? 'org:apt:templatecategories'
                            : "org:".concat(selectedOrganizationId, ":templatecategories") }, { children: _jsx(Input, { placeholder: "Category label", value: label, onChange: function (e) { return setLabel(e.target.value); } }) })), _jsx(PermissionsWrapper, __assign({ action: "update", target: "org:apt:templatecategories" }, { children: _jsx(Checkbox, { checked: global, label: "Global", onChange: function () { return setGlobal(!global); } }) }))] })) }) })));
};
